import { ReactNode } from "react";

import "./ConnectWalletButton.scss";
import { useMedia } from "react-use";

import Button from "components/Button/Button";

import cx from "classnames";

type Props = {
  children: ReactNode;
  onClick: () => void;
};

export default function ConnectWalletButton({ children, onClick }: Props) {
  const isMobile = useMedia("(max-width: 648px)");

  return (
    <Button
      variant="primary"
      size="small"
      className={cx("connect-wallet-btn", isMobile ? "is-mobile" : "")}
      onClick={onClick}
      data-qa="connect-wallet-button"
    >
      <span className="btn-label">{children}</span>
    </Button>
  );
}
